import * as React from "react";
import type { SVGProps } from "react";
const SvgAirportIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M26.465 22.354H1.845v1.07h24.62zM26.092 5.492c-1.788-1.042-3.82-.489-5.209.16l-4.141 1.93L9.619 4l-4.241.182 5.881 5.963-3.748 1.78-3.9-1.484L1 11.66l2.36 2.93c-.25.297-.476.716-.27 1.156.267.574 1.06.864 2.358.864q.4 0 .863-.037c1.425-.112 2.97-.476 3.937-.927l14.804-6.903c1.278-.596 1.915-1.222 1.947-1.914.016-.359-.128-.882-.907-1.336m-1.493 2.28L9.796 14.675c-.824.384-2.175.706-3.444.82-1.297.116-1.99-.03-2.221-.154.047-.066.136-.168.3-.312l.385-.338-2.125-2.64.962-.449 3.904 1.486 5.522-2.623-5.245-5.317 1.553-.067 7.337 3.69 4.611-2.15c1.685-.785 3.103-.854 4.218-.204.28.163.379.306.376.362 0 .004-.032.388-1.33.993"
    />
  </svg>
);
export default SvgAirportIcon;
